<div class="layout-ParentDiv innerDiv">
	<div class="layout-dashboard" [ngClass]="hide ? 'responsiveHide-column' : 'responsiveShow-column'">
		<div class="mainDivHeader">
			<div class="leftdiv">
				<h4>Membership <span class="badge">{{totalRecords }}</span></h4>
			</div>
			<div class="rightDiv">
				<button class="exportBTn" (click)="exportExcel()"> <span><img
							src="../../../assets/images/backend-image/header/exportIcon.svg" alt=""></span>
					Export</button>
				<button class="addBTn" (click)="addNewMembership()"> <span>
						<img src="../../../assets/images/backend-image/header/plus.svg" alt=""></span> Add New
					Membership </button>
			</div>
		</div>
		<div class="mainDivBody">
			<div class="date-filterDiv">
				<ul class="filtersList">
					<li>
						<p-dropdown inputId="searchfield" [options]="searchBy" [(ngModel)]="searchby" placeholder="Select Field" optionLabel="label"></p-dropdown>
					</li>
					<li>
						<p-calendar [(ngModel)]="startDate" appendTo="body" 
						monthNavigator="true" yearNavigator="true" 
						yearRange="2022:2050" class="p-calendar w-100" 
						dateFormat="dd/mm/yy" placeholder="From: dd / mm / yy" 
						[showIcon]="true">
						</p-calendar>
					</li>
					<li>
						<p-calendar [(ngModel)]="endDate" appendTo="body" 
						monthNavigator="true" yearNavigator="true" 
						yearRange="2022:2050" class="p-calendar" 
						dateFormat="dd/mm/yy" placeholder="To: dd / mm / yy" 
						[showIcon]="true">
						</p-calendar>
					</li>
					<li>
						<button class="searchFilterBtn" (click)="searchWithDateFilter()">
						<img src="../../../assets/images/backend-image/common-images/search.svg" alt="">
						</button>
					</li>
					<li>
						<button (click)="clear()" class="clearFilterBtn">
							<img src="../../../assets/images/backend-image/common-images/delete.svg" alt="">
							<span>Clear All</span>
						</button>
					</li>
				</ul>

			</div>
			<div class="maintableDiv">
				<div class="tableParanet">
					<p-table #dt [value]="membershiplist" [paginator]="true" [rows]="10" [lazy]="true"
						(onLazyLoad)="loadMemberships($event)" [totalRecords]="totalRecords"
						[rowsPerPageOptions]="paginationOption"
						styleClass="p-datatable-gridlines p-datatable-striped p-datatable">
						<ng-template pTemplate="header" let-columns>
							<tr>
								<th pSortableColumn="planName" class="titleTD">
									<div class="p-d-flex p-jc-between p-ai-center">
										Plan Name
										<p-sortIcon field="planName"></p-sortIcon>
									</div>
								</th>

								<th class="viewBtnTd">
									<div class="p-d-flex p-jc-between p-ai-center">
										Benefits
									</div>
								</th>
								<th pSortableColumn="membershipType" class="membershipTypeTD">
									<div class="p-d-flex p-jc-between p-ai-center">
										Membership Type
										<p-sortIcon field="membershipType"></p-sortIcon>
									</div>
								</th>
								<th pSortableColumn="sportdata" class="sportTD">
									<div class="p-d-flex p-jc-between p-ai-center">
										Sport
										<p-sortIcon field="sportdata"></p-sortIcon>
									</div>
								</th>
								<th pSortableColumn="currency" class="currencyTD">
									<div class="p-d-flex p-jc-between p-ai-center">
										Currency
										<p-sortIcon field="currency"></p-sortIcon>
									</div>
								</th>
								<th pSortableColumn="price" class="priceTD">
									<div class="p-d-flex p-jc-between p-ai-center">
										Price
										<p-sortIcon field="price"></p-sortIcon>
									</div>
								</th>
								<th pSortableColumn="discountPrice" class="discountPriceTD">
									<div class="p-d-flex p-jc-between p-ai-center">
										Discount Price
										<p-sortIcon field="discountPrice"></p-sortIcon>
									</div>
								</th>
								<th pSortableColumn="duration" class="durationTD">
									<div class="p-d-flex p-jc-between p-ai-center">
										Duration
										<p-sortIcon field="duration"></p-sortIcon>
									</div>
								</th>
								<th pSortableColumn="status" class="statusTD">
									<div class="p-d-flex p-jc-between p-ai-center">
										Status
										<p-sortIcon field="status"></p-sortIcon>
									</div>
								</th>

								<th pSortableColumn="created_at" class="createdDateTD" [ngClass]="hide ? 'hide-column' : 'show-column'">
									<div class="p-d-flex p-jc-between p-ai-center">
										Date of Creation
										<p-sortIcon field="created_at"></p-sortIcon>
									</div>
								</th>
								<th pSortableColumn="created_by" class="CreatedByTD" [ngClass]="hide ? 'hide-column' : 'show-column'">
									<div class="p-d-flex p-jc-between p-ai-center">
										Created By
										<p-sortIcon field="created_by"></p-sortIcon>
									</div>
								</th>
								<th pSortableColumn="updated_at"  [ngClass]="hide ? 'hide-column' : 'show-column'">
									<div class="p-d-flex p-jc-between p-ai-center">
										Modified On
										<p-sortIcon field="updated_at"></p-sortIcon>
									</div>
								</th>
								<th pSortableColumn="updated_by" [ngClass]="hide ? 'hide-column' : 'show-column'">
									<div class="p-d-flex p-jc-between p-ai-center">
										Modified By
										<p-sortIcon field="updated_by"></p-sortIcon>
									</div>
								</th>

								<th class=" actionTD p-frozen-column"> 
										Action 
								</th>

							</tr>
							<tr>
								<th [ngSwitch]="planName" class="titleTD">
									<input pInputText type="text"
										(keyup.enter)="dt.filter($event.target.value, 'planName', 'contains')"
										style="width: 100%;"
										[value]="dt.filters['planName'] ? dt.filters['planName'].value : ''" />
								</th>
								<th class="viewBtnTd">

								</th>
								<th [ngSwitch]="membershipType" class="membershipTypeTD">
									<p-dropdown #pDropDownId3 [options]="membershipTypeList" [(ngModel)]="mcalvalue"
										(onChange)="dt.filter($event.value, 'membershipType', 'equals')" appendTo="body"
										styleClass="p-column-filter" placeholder="Select Membership Type" [showClear]="true">
										<ng-template let-option pTemplate="item">
											<span
												[class]="'customer-badge status-' + option.value">{{option.label}}</span>
										</ng-template>
									</p-dropdown>
								</th>
								<th [ngSwitch]="sportdata" class="sportTD">
									<p-dropdown #pDropDownId1 [options]="sportTypeList" [(ngModel)]="sportFilterValue"
										(onChange)="dt.filter($event.value, 'sport', 'equals')" appendTo="body" styleClass="p-column-filter"
										placeholder="Select Sport" [showClear]="true">
										<ng-template let-option pTemplate="item">
											<span
												[class]="'customer-badge status-' + option.value">{{option.label}}</span>
										</ng-template>
									</p-dropdown>
								</th>
								<th [ngSwitch]="currency" class="currencyTD">
									<p-dropdown #pDropDownId2 [options]="currencyList" [filter]="true"
										[(ngModel)]="dcalvalue" appendTo="body"
										(onChange)="dt.filter($event.value, 'currency', 'equals')"
										styleClass="p-column-filter" placeholder="Select currency" [showClear]="true">
										<ng-template let-option pTemplate="item">
											<span
												[class]="'customer-badge status-' + option.value">{{option.label}}</span>
										</ng-template>
									</p-dropdown>
								</th>
								<th [ngSwitch]="price" class="priceTD">
									<input pInputText type="text"
										(keyup.enter)="dt.filter($event.target.value, 'price', 'contains')"
										style="width: 100%;"
										[value]="dt.filters['price'] ? dt.filters['price'].value : ''" />
								</th>
								<th [ngSwitch]="discountPrice" class="discountPriceTD">
									<input pInputText type="text" (keyup.enter)="dt.filter($event.target.value, 'discountPrice', 'contains')"
										style="width: 100%;" [value]="dt.filters['discountPrice'] ? dt.filters['discountPrice'].value : ''" />
								</th>

								<th [ngSwitch]="duration" class="durationTD">
									<input pInputText type="text"
										(keyup.enter)="dt.filter($event.target.value, 'duration', 'contains')"
										style="width: 100%;"
										[value]="dt.filters['duration'] ? dt.filters['duration'].value : ''" />
								</th>
								<th [ngSwitch]="status" class="statusTD">
									<p-dropdown #statusDropdown [options]="statuses" [(ngModel)]="status"
										(onChange)="dt.filter($event.value, 'status', 'equals')" styleClass="p-column-filter"
										placeholder="Select Status" [showClear]="true">
										<ng-template let-option pTemplate="item">
											<span
												[class]="'customer-badge status-' + option.value">{{option.label}}</span>
										</ng-template>
									</p-dropdown>
								</th>
								<th [ngSwitch]="created_at" class="createdDateTD" [ngClass]="hide ? 'hide-column' : 'show-column'">
									<p-calendar #pCalendarId2 class="p-column-filter" inputId="calendar" appendTo="body"
										dateFormat="dd/mm/yy" (onSelect)="dt.filter($event,'created_at', 'dateIs')"
										[showIcon]="true" monthNavigator="true" yearNavigator="true"
										yearRange="2022:2050" [(ngModel)]="calvalue"></p-calendar>
								</th>
								<th [ngSwitch]="createdby" class="CreatedByTD" [ngClass]="hide ? 'hide-column' : 'show-column'">
									<input pInputText type="text"
										(keyup.enter)="dt.filter($event.target.value, 'createdby', 'contains')"
										style="width: 100%;"
										[value]="dt.filters['createdby'] ? dt.filters['createdby'].value : ''" />
								</th>
								<th [ngSwitch]="updated_at" [ngClass]="hide ? 'hide-column' : 'show-column'">
									<p-calendar #pCalendarId class="p-column-filter" inputId="calendar" appendTo="body"
										dateFormat="dd/mm/yy" (onSelect)="dt.filter($event,'updated_at', 'dateIs')"
										[showIcon]="true" monthNavigator="true" yearNavigator="true"
										yearRange="2022:2050" [(ngModel)]="ucalvalue"></p-calendar>
								</th>
								<th [ngSwitch]="updatedby" [ngClass]="hide ? 'hide-column' : 'show-column'">
									<input pInputText type="text"
										(keyup.enter)="dt.filter($event.target.value, 'updatedby', 'contains')"
										style="width: 100%;"
										[value]="dt.filters['updatedby'] ? dt.filters['updatedby'].value : ''" />
								</th>

									<th class="actionTD p-frozen-column">
									<div class="buttonColumn">
										<button class="addBTn" (click)="addColumns()"
											[ngClass]="hide ? 'show-column ' : 'hide-column'">
											+ Show Column
										</button>
										<button class="removeBTn" (click)="removeColumns()"
											[ngClass]="hide ? 'hide-column' : 'show-column '">
											- Hide Column
										</button>

									</div>
								</th>
							</tr>
						</ng-template>
						<ng-template pTemplate="body" let-membership>
							<tr class="p-selectable-row">
								<td class="titleTD">
									{{membership?.planName}}
								</td>
								<td class="viewBtnTd">
									<button pButton *ngIf="membership?.benefit.length > 0" type="button"
										icon="pi pi-eye" label="View"
										(click)="viewBenefits(membership?.benefit)"></button>
								</td>
								<td class="membershipTypeTD">
									{{ (membership?.membershipType) ? (membership?.membershipType | titlecase) : '' }}
								</td>
								<td class="sportTD">
									{{ (membership?.sport) ? membership?.sport[0]?.name : '' }}
								</td>
								<td class="currencyTD">
									{{membership?.currency}}
								</td>
								<td class="priceTD">
									{{ membership?.price }}
								</td>
								<td class="discountPriceTD">
									{{ membership?.discountPrice }}
								</td>
								<td class="durationTD">
									{{ membership?.duration }}
								</td>
								<td class="text-center statusTD">
									<div class="status-div ">
										<div class="swichTable">
											<p-inputSwitch [(ngModel)]="membership.status"
												(onChange)="changeStatus(membership)" class="p-d-flex"></p-inputSwitch>
											<div class="label activeText" *ngIf="membership.status">
												Active
											</div>
											<div class="label InActiveText" *ngIf="!membership.status" style="color: #686868;">
												Inactive
											</div>
										</div>
									</div>

									<!-- <p-inputSwitch [(ngModel)]="membership.status"
										(onChange)="changeStatus(membership)"></p-inputSwitch> -->
								</td>

								<td class="createdDateTD" [ngClass]="hide ? 'hide-column' : 'show-column'">
									{{membership.created_at | date: 'dd/MM/yyyy'}}
								</td>
								<td class="CreatedByTD" [ngClass]="hide ? 'hide-column' : 'show-column'">
									{{membership.createdBy}}
								</td>
								<td [ngClass]="hide ? 'hide-column' : 'show-column'">
									<span
										*ngIf="membership.updated_at != undefined && membership.updated_at  !='Invalid Date'">{{membership.updated_at
										| date: 'dd/MM/yyyy'}}</span>
								</td>
								<td [ngClass]="hide ? 'hide-column' : 'show-column'">
									{{membership.updatedBy}}
								</td>
								<td class="actionTD p-frozen-column">
										<ul class="actionList">
										<li>
											<button (click)="editMembership(membership.id) "
												class="editBtn"><img
													src="../../../assets/images/backend-image/common-images/editeBtn.svg"></button>
										</li>
										<li>
											<button (click)="deleteMembership(membership)" class="deleteBtn"><img
													src="../../../assets/images/backend-image/common-images/deleteBtn.svg"></button>
										</li>
									</ul> 
								</td>
							</tr>
						</ng-template>
						<ng-template pTemplate="emptymessage">
							<tr>
								<td colspan="12">No Memberships found.</td>
							</tr>
						</ng-template>

					</p-table>
				</div>
			</div>
		</div>
	</div>
</div>


<p-dialog header="Benefits" [(visible)]="isBenefitsAvailable" [style]="{width: '400px'}" id="PoList" modal="true" draggable="false">

	<p-table [value]="benefits" styleClass="p-datatable-sm" class="DistributionTable">
		<ng-template pTemplate="header">
			<tr>
				<th class="APCPOtd-div">Key</th>
				<th class="APCPODatetd-div">Value</th>
		</ng-template>
		<ng-template pTemplate="body" let-benefit let-index="rowIndex">
			<tr>
				<td class="APCPOtd-div">{{benefit?.key}}</td>
				<td class="APCPODatetd-div">{{benefit?.value}}</td>
			</tr>
		</ng-template>
		
	</p-table>

</p-dialog>
<p-confirmDialog [style]="{width:'400px'}" id="confirmDialog"></p-confirmDialog>
